import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getPossibleValuesForColumns(
    ResultID,
    Column,
    {ClientID, LocalUserID} = {}
) {
    const {_LocalUserID, _ClientID} = getUserApiData({ClientID, LocalUserID});
    return invokeApig({
        ...Paths.getPossibleValuesForColumns({
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: {
            ResultID,
            Column,
        },
    });
}
